module.exports = __webpack_public_path__ + "img/img-qrcode-mock.81fbf298.png";